import {createSelector} from "@ngrx/store";
import {FeatureKey} from '../constants';
import {GridTypeObj, GridViewCustomFilters, GridViewSelect, GridViewsState} from "../types";
import {HeaderCellConfiguration} from "@wcg/frontend-framework";

export const getCustomViews = createSelector(
  (state: any) => state[FeatureKey],
  (gridViews: GridViewsState) => gridViews &&  gridViews?.customViews as GridTypeObj
)

export const getGridType = createSelector(
  (state: any) => state[FeatureKey],
  (grid: GridViewsState) => grid?.gridType && grid?.gridType
)

export const getSelectedView = createSelector(
  (state: any) => state[FeatureKey],
  (grid: GridViewsState) => grid?.selectedView && grid?.selectedView as GridViewSelect
)

export const getDefaultHeaders = createSelector(
  (state: any) => state[FeatureKey],
  (gridView: GridViewsState) => gridView?.defaultHeaders as HeaderCellConfiguration[]
)

export const getCustomFilters = createSelector(
  (state: any) => state[FeatureKey],
  (gridViewState: GridViewsState) => gridViewState?.customFilters as GridViewCustomFilters
)
